(function () {
  function init() {
    var desc = document.querySelector('.product__description');
    if (!desc) return;

    var h5s = Array.from(desc.querySelectorAll('h5'));
    if (h5s.length === 0) return;

    desc.classList.add('lpv-desc-has-accordion');

    var chevronSVG =
      '<svg class="lpv-desc-accordion__chevron" xmlns="http://www.w3.org/2000/svg" ' +
      'width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<polyline points="6 9 12 15 18 9"/></svg>';

    h5s.forEach(function (h5, idx) {
      var id = 'lpv-desc-acc-' + idx;
      var bodyId = 'lpv-desc-body-' + idx;

      var details = document.createElement('details');
      details.className = 'lpv-desc-accordion__item';
      details.id = id;
      if (idx === 0) details.open = true;

      var summary = document.createElement('summary');
      summary.className = 'lpv-desc-accordion__summary';
      summary.setAttribute('aria-expanded', idx === 0 ? 'true' : 'false');
      summary.setAttribute('aria-controls', bodyId);
      summary.innerHTML = '<span>' + (h5.textContent || h5.innerText) + '</span>' + chevronSVG;

      var body = document.createElement('div');
      body.className = 'lpv-desc-accordion__body rte';
      body.id = bodyId;
      body.setAttribute('role', 'region');
      body.setAttribute('aria-labelledby', id);

      var sibling = h5.nextSibling;
      while (sibling) {
        var next = sibling.nextSibling;
        if (sibling.nodeType === 1 && sibling.tagName === 'H5') break;
        body.appendChild(sibling);
        sibling = next;
      }

      details.appendChild(summary);
      details.appendChild(body);
      h5.parentNode.replaceChild(details, h5);
    });

    desc.addEventListener('toggle', function (e) {
      if (!e.target.classList.contains('lpv-desc-accordion__item') || !e.target.open) return;
      desc.querySelectorAll('details.lpv-desc-accordion__item').forEach(function (d) {
        if (d !== e.target) {
          d.open = false;
          d.querySelector('summary').setAttribute('aria-expanded', 'false');
        }
      });
      e.target.querySelector('summary').setAttribute('aria-expanded', 'true');
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
